import moment from 'moment';
import uniqBy from 'lodash.uniqby';
import getApi from '../tools/api/progress';
import {get, post} from '../tools/http';

const api = getApi({ isMock: false });

function uniqueCompetences(programs) {
    const uniqueCompetences = [];
    for (const program of programs) {
        for (const uniqueCompetence of uniqBy(program.competences,'id')) {
            uniqueCompetences.push(uniqueCompetence);
        }
    }
    return uniqBy(uniqueCompetences, 'id');
}

function prepareProfession(v) {
    v.publicationLink =  v.entityType === 'profession' ? {
        name: 'profession-details',
        params: { professionId: v.profileId },
    } : {
        name: 'specialization-details',
        params: { specializationId: v.profileId },
    };
    return v;
}

function prepareProgram(v) {
    let now = moment();

    v.isRsvLms = v.educationType === 'rsv_course' || v.educationType === 'rsv_webinar';

    function prepareCardQuestions(v) {
        v.cardQuestions = {};
        v.cardQuestions['isStarted'] = (!v.isRsvLms && v.status === 'planned' && v.moment.start.isBefore(now));
        v.cardQuestions['isCompleted'] = (!v.isRsvLms && (v.status === 'planned' || v.status === 'started') && v.moment.end.isBefore(now));
        v.cardQuestions['isLmsUpdate'] = v.isRsvLms && v.status !== 'completed' && v.moment.end.isBefore(now);

        v.hasUpdates = v.cardQuestions.isStarted
            || v.cardQuestions.isCompleted
            || v.cardQuestions.isLmsUpdate
        ;
    }

    v.programType = (v.entityType === 'program' || v.entityType === 'full_time')
        ? v.educationType
        : v.entityType;

    v.moment = null;
    if (v.startAt !== null) {
        moment.locale('ru');
        let duration = moment.duration(v.durationInterval);
        v.moment = {
            start: moment(v.startAt),
            end: moment(v.startAt).add(duration),
            duration,
        };


        v.hasFutureDate = v.isAnyTimeStart ||
            v.programBeginnings.findIndex(v => moment(v.date).isAfter(now) || v.interval !== null) > -1;

        prepareCardQuestions(v);
        if (v.modules.length > 0) {
            v.modules = v.modules.reduce((acc, module, i) => {
                let moduleDuration = moment.duration(module.durationInterval);
                if (acc.length > 0) {
                    module.moment = {
                        start: acc[i - 1].moment.end.clone(),
                        end: acc[i - 1].moment.end.clone().add(moduleDuration),
                        duration: moduleDuration,
                    };
                } else {
                    module.moment = {
                        start: v.moment.start.clone(),
                        end: v.moment.start.clone().add(moduleDuration),
                        duration: moduleDuration,
                    };
                }

                prepareCardQuestions(module);

                module.hasUpdates = module.cardQuestions.isStarted
                    || module.cardQuestions.isCompleted
                    || module.cardQuestions.isLmsUpdate
                ;

                acc.push(module);
                return acc;
            }, []);
        }
    }
    if(!v.isAnyTimeStart) {
        v.dateList = generateDateList(v.programBeginnings, 10, v.id);
    }
    v.isRsvLms = v.educationType === 'rsv_course' || v.educationType === 'rsv_webinar';

    return v;
}

function prepareCompetence(v) {
    if (v.updatedAt !== null) {
        v.moment = {
            updatedAt: moment(v.updatedAt),
        };
    }
    v.publicationLink = v.competenceType === 'soft' ? {
        name: 'competence',
        params: { id: v.id },
    } : {
        name: 'professional-skill',
        params: { id: v.id },
    };
    return v;
}

function sortAndFilterDates(dates, counter) {
    return dates
        .sort((a, b) => {
            if (moment(a).isBefore(moment(b))) {
                return -1;
            }
            if (moment(a).isAfter(moment(b))) {
                return 1;
            }
            return 0;
        })
        .filter((e, i, a) => a.findIndex(v => moment(e).isSame(moment(v))) === i)
        .filter((v, i) => i < counter);
}

function hS(x) {
    return x < 0 ? 0 : 1;
}

function getDateAround(currentDate, startDate, interval, flag) {
    const current = moment(currentDate).valueOf();
    const start = moment(startDate).valueOf();
    const duration = moment.duration(interval).asMilliseconds();

    const d = (current - start) / duration;
    let preD = null;
    if (flag === 'pre') {
        preD = Math.trunc(d) + (hS(d) - 1);
    } else {
        preD = Math.trunc(d) + hS(d);
    }
    return generateNextDate(startDate, interval, preD);
}

function generateNextDate(startDate, interval, count) {
    let result = startDate;
    for (let i = 1; i <= Math.abs(count); i++) {
        if (count > 0) {
            result = moment(result).add(interval).format('YYYY-MM-DD');
        } else if (count < 0) {
            result = moment(result).subtract(interval).format('YYYY-MM-DD');
        }
    }
    return result;
}

function generateDates(startDate, interval, counter) {
    const now = moment().format('YYYY-MM-DD');
    let start = startDate;
    if (moment(startDate).isBefore(moment(now))) {
        start = getDateAround(
            now,
            startDate,
            interval,
            'next',
        );
    }
    let dateList = [];
    dateList.push(start);
    let middleDate = start;
    for(let i = 0; i < counter - 1; i++) {
        middleDate = generateNextDate(middleDate, interval, 1);
        dateList.push(middleDate);
    }
    return dateList;
}

function generateDateList(dates, counter, id) {
    // dates:
    //     "id": 0,
    //     "date": "2020-11-09",
    //     "interval": "P0Y1M0DT0H0M",

    let datesWithoutInterval = dates.filter(v => !v.interval);
    let datesWithInterval = dates.filter(v => v.interval);

    if (datesWithInterval.length === 0) {
        return sortAndFilterDates([...datesWithoutInterval.map(v => v.date)], counter);
    } else {
        let dateList = datesWithInterval.map(v => generateDates(
            v.date,
            v.interval,
            counter,
        ));

        return sortAndFilterDates(
            [
                ...dateList.flat(),
                ...datesWithoutInterval.map(v => v.date),
            ],
            counter,
        );
    }
}

export default {
    namespaced: true,
    state: () => ({
        pageContent: null,
        track: null,
        isTrackReady: false,
        competences: [],
        programs: [],
        competenceLevels: [
            {
                name: 'Экспертный',
                key: 'advanced',
            },
            {
                name: 'Средний',
                key: 'intermediate',
            },
            {
                name: 'Базовый',
                key: 'basic',
            },
            {
                name: '',
                key: null,
            },
        ],
        competenceKnowledge: ['Знаю', 'Не знаю'],
        professions: [],
        lastAccountProject: null,
        lastAccountProjectSPK2: null,
        lastAccountProjectCount: null,
        lastAccountProjectSPK2Count: null,
        lastAccountEvent: null,
        lastAccountEventCount: null,
        accountReports: null,
        accountReportsCount: null,
        proftestId: null,
        professionRecommendations: [],
        currentProgramIntoTrack: false,
    }),

    mutations: {
        setTrack: (state, item) => {
            state.track = item;
        },
        setAccountReports: (state, item) => state.accountReports = item,
        setAccountReportsCount: (state, item) => state.accountReportsCount = item,
        setLastAccountProject: (state, item) => state.lastAccountProject = item,
        setLastAccountProjectSPK2: (state, item) => state.lastAccountProjectSPK2 = item,
        setLastAccountEvent: (state, item) => state.lastAccountEvent = item,
        setLastAccountProjectCount: (state, item) => state.lastAccountProjectCount = item,
        setLastAccountProjectSPK2Count: (state, item) => state.lastAccountProjectSPK2Count = item,
        setLastAccountEventCount: (state, item) => state.lastAccountEventCount = item,
        setIsTrackReady: (state, ready) => state.isTrackReady = state,
        setCompetences: (state, items) => state.competences = items.map(prepareCompetence),
        setPrograms: (state, items) => state.programs = items.map(prepareProgram),
        replaceProgram: (state, item) => {
            let items = state.programs.slice();
            let index = items.findIndex(v => v.id === item.id);
            if (index > -1) {
                items.splice(index, 1, prepareProgram(item));
            }
            state.programs = items;
        },
        replaceCompetence: (state, item) => {
            let items = state.competences.slice();
            let index = items.findIndex(v => v.id === item.id);
            if (index > -1) {
                items.splice(index, 1, prepareCompetence(item));
            }
            state.competences = items;
        },
        setProfessions: (state, items) => state.professions = items.map(prepareProfession),
        setPageContent: (state, data) => state.pageContent = data,
        setProftestId: (state, data) => state.proftestId = data,
        setProfessionRecommendations: (state, data) => state.professionRecommendations = data,
    },

    actions: {
        async loadAllAccountProjects(ctx) {
            let allCount;
            const path = `api/v1/seasons/nomination/get-my-nomination?sort[0][order]=DESC&sort[0][column]=dateStart&filter[status]=active&type=`;
            let contests = await get('projects', `${path}contests`, {}, true);
            let internship = await get('projects', `${path}internship`, {}, true);
            let events = await get('projects', `${path}events`, {}, true);
            let center = await get('projects', `${path}centres_of_competitions`, {}, true);
            let project = await get('projects', `${path}project`, {}, true);
            allCount = (contests.data ? contests.data.length : 0)
             + (internship.data ? internship.data.length : 0) 
             + (events.data ? events.data.length : 0) 
             + (center.data ? center.data.length : 0) 
             + (project.data ? project.data.length : 0);
            ctx.commit('setLastAccountProjectCount', allCount || 0);
        },
        async loadAccountProjects(ctx) {
            const queryParts = [
                'sort[0][order]=DESC',
                'sort[0][column]=dateStart',
                'withoutExternal=true',
                'filter[status]=active',
            ].join('&');

            const path = `api/v1/seasons/nomination/get-my-nomination?${queryParts}`;
            let res = await get('projects', `${path}contests`, {}, true);

            if (res.data && res.data.length  && res.data[0]) {
                ctx.commit('setLastAccountProject', res.data[0]);
            } else {
                res = await get('projects', `${path}&type=internship`, {}, true);

                if (res.data) {
                    if (res.data.length && res.data[0]) {
                        ctx.commit('setLastAccountProject', res.data[0]);
                    } else {
                        res = await get('projects', `${path}&type=events`, {}, true);

                        if(res.data && res.data.length && res.data[0]) {
                            ctx.commit('setLastAccountProject', res.data[0]);
                        } else {
                            ctx.commit('setLastAccountProject', null);
                        }
                    }
                }
            }
        },
        async loadAccountProjectsSPK2 (ctx) {
            const path = 'api/v1/project/current';
            let sbStringUrl = [
                'take=1',
                'completed=false',
            ];
            const domainToIdMap = {
                'rsv-test-2.bizml.ru': 69327,
                'rsv-test.bizml.ru': 70923,
                'rsv-demo.bizml.ru': 214074,
                'rsv-dev.bizml.ru': 59022,
            };
            const vacancyType = domainToIdMap[window.rsvDomain] || 218740;
            ctx.commit('writeInvolvedProjectsSPK2', []);

            try {
                const res = await get('data', 'catalog/get/spk_project_type', null, true);
                res.data
                    .filter(item => item.field_name !== 'internship')
                    .forEach(item => {
                        if(item.id !== vacancyType) {
                            sbStringUrl.push(`filter[type]=${item.id}`);
                        }
                    });
            } catch(e) {
                console.log(e);
            } finally {
                const res = await get('projects2', `${path}?${sbStringUrl.join("&")}`, null, true);
                ctx.commit('setLastAccountProjectSPK2', res.data[0] );
            }
        },

        async loadAllAccountProjectsSPK2 (ctx) {
            const path = 'api/v1/project/current';
            let sbStringUrl = [
                'take=1',
            ];
            const domainToIdMap = {
                'rsv-test-2.bizml.ru': 69327,
                'rsv-test.bizml.ru': 70923,
                'rsv-demo.bizml.ru': 214074,
                'rsv-dev.bizml.ru': 59022,
            };
            const vacancyType = domainToIdMap[window.rsvDomain] || 218740;
            ctx.commit('writeInvolvedProjectsSPK2', []);

            try {
                const res = await get('data', 'catalog/get/spk_project_type', null, true);
                res.data
                    .filter(item => item.field_name !== 'internship')
                    .forEach(item => {
                        if(item.id !== vacancyType) {
                            sbStringUrl.push(`filter[type]=${item.id}`);
                        }
                    });
            } catch(e) {
                console.log(e);
            } finally {
                const res = await get('projects2', `${path}?${sbStringUrl.join("&")}`, null, true);
                ctx.commit('setLastAccountProjectSPK2Count', res.total );
            }
        },

        async loadAccountEvents(ctx) {
            const path = 'event/all?filter[status]=public,private&sort[0][column]=statusUpdatedAt&sort[0][order]=DESC&limit=9000&offset=0'
            + '&filter[type]=course&filter[self]=true&filter[participantStatuses][]=admin_confirmed_request'
            + '&filter[participantStatuses][]=user_confirmed_request';
            const res = await get('event', path, {}, true);
            if (res.data) {
                ctx.commit('setLastAccountEvent', res.data.events[0] || {});
                ctx.commit('setLastAccountEventCount', res.data.count || '');
            }
        },
        async loadReportsList(ctx) {
            const allReportsList = await get('reporting', 'api/v1/report/listreport', {}, true);
            if (allReportsList.data) {
                ctx.commit('setAccountReportsCount', allReportsList.data.length || '');
            }
            const res = await get('reporting', 'api/v1/report/listreport?skip=0&take=4', {}, true);
            if (res.data) {
                ctx.commit('setAccountReports', res.data);
            }
        },
        async loadTrack(ctx, { view = null } = {}) {
            ctx.commit('setIsTrackReady', false);
            ctx.commit('setTrack', null);
            ctx.commit('setCompetences', []);
            ctx.commit('setProfessions', []);
            ctx.commit('setPrograms', []);
            let res = await api.fetchTracks();
            if (res) {
                let track = res.items.find(v => v.status === 'active');
                if (track === undefined) {
                    track = await api.createTrack();
                }
                ctx.commit('setTrack', track);

                await Promise.all([
                    ctx.dispatch('loadCompetences', ctx.getters.getTrackId),
                    ctx.dispatch('loadPrograms'),
                    ctx.dispatch('loadProfessions', { trackId: ctx.getters.getTrackId, view }),
                ]);
                ctx.commit('setIsTrackReady', true);
            } else {
                ctx.commit('setIsTrackReady', false);
            }

        },
        async loadCompetences(ctx) {
            let res = await api.fetchTrackCompetences(ctx.getters.getTrackId);
            res && ctx.commit('setCompetences', res.items);
        },
        async loadPrograms(ctx) {
            let res = await api.fetchTrackPrograms(ctx.getters.getTrackId);
            res && ctx.commit('setPrograms', res.items);
        },
        async removeProgram(ctx, { programId }) {
            let res = await api.updateProgram(programId, { trackId: null });
            res && ctx.commit('setPrograms', ctx.state.programs.filter(v => v.id !== programId));
        },
        async scheduleProgram(ctx, { programId, startAt }) {
            let res = await api.updateProgramStatus(programId, { action: 'schedule', startAt });
            res && ctx.commit('replaceProgram', res);
        },
        async cancelProgram(ctx, { programId }) {
            let res = await api.updateProgramStatus(programId, { action: 'cancel' });
            res && ctx.commit('replaceProgram', res);
        },
        async startProgram(ctx, { programId, moduleId = null }) {
            let res = await api.updateProgramStatus(programId, { action: 'start', moduleId });
            res && ctx.commit('replaceProgram', res);
        },
        async completeProgram(ctx, { programId, moduleId = null }) {
            let res = await api.updateProgramStatus(programId, { action: 'complete', moduleId });
            res && ctx.commit('replaceProgram', res);
        },
        async setCompetenceAcknowledge(ctx, { competenceId, status }) {
            let res = await api.updateCompetence(competenceId, { userAcknowledgment: status });
            res && ctx.commit('replaceCompetence', res);
        },
        async loadProfessions(ctx, { trackId, view = null }) {
            let res = await api.fetchTrackProfiles(trackId, { view });
            res && ctx.commit('setProfessions', res.items);
        },
        async removeProfessions(ctx, id) {
            let res = await api.removeTrackProfile(id);
            res && ctx.commit('setProfessions', ctx.state.professions.slice()
                .filter(v => v.profileId !== id));
        },
        async loadTrackPage(ctx, trackId) {
            let res = await get('cms', `entity/select/page?name=account-track`);
            if (res.list.length > 0) {
                res && ctx.commit('setPageContent', res.list[0].data);
            }
        },
        async removeCompetenceFromTrack(ctx, { competenceId, trackId }) {
            await api.removeTrackCompetence(competenceId, { trackId });
            ctx.dispatch('loadCompetences', trackId);
        },
        async loadProftest(ctx ) {
            let test = await api.fetchSpecialTest('proftest');
            if (!test) {
                ctx.commit('setProftestId', null);
            }
            ctx.commit('setProftestId', test.foreignTestId);
        },
        async loadProfessionRecommendations(ctx ) {
            let professions = await api.fetchRecommendedProfessions();
            ctx.commit('setProfessionRecommendations', professions);
        },
        async loadUserPrograms(ctx, programIds) {
            const res = await api.fetchUserPrograms(programIds);
            if (res && res.items && res.items.length > 0) {
                return res.items;
            }
            return null;
        },
        async addCompetenceToTrack(ctx, compId) {
            await api.addCompetenceToTrack(ctx.getters.getTrackId, compId);
            await ctx.dispatch('loadCompetences', ctx.getters.getTrackId);
        },
        async addProfessionToTrack(ctx, profId) {
            await api.addProfessionToTrack(ctx.getters.getTrackId, profId);
            await ctx.dispatch('loadProfessions', { trackId: ctx.getters.getTrackId });
            ctx.commit('singleProfession/setIsProfessionAdded', true, { root: true });
        },
        async addProgramToTrack(ctx, programId) {
            let program = await api.addProgramToTrack(ctx.getters.getTrackId, programId);
            let items = ctx.state.programs.slice();
            let index = items.findIndex(v => v.id === program.id);
            if (index > -1) {
                items.splice(index, 1, program);
            } else {
                items.push(program);
            }
            ctx.commit('setPrograms', items);
        },
    },

    getters: {
        getAccountReportsCount: state => state.accountReportsCount,
        getAccountReports: state => state.accountReports,
        getLastAccountProject: state => state.lastAccountProject,
        getLastAccountProjectSPK2: state => state.lastAccountProjectSPK2,
        getLastAccountProjectCount: state => state.lastAccountProjectCount,
        getLastAccountProjectSPK2Count: state => state.lastAccountProjectSPK2Count,
        getLastAccountEvent: state => state.lastAccountEvent,
        getLastAccountEventCount: state => state.lastAccountEventCount,
        getTrack: state => state.track,
        getTrackId: state => state.isTrackReady ? state.track.id : null,
        getIsTrackReady: state => state.track && state.isTrackReady,
        getTrackStatus: state => state.track ? state.track.status : null,
        getTimelinePrograms: state => state.programs.filter((v) => v.moment),
        getBucketPrograms: state => state.programs.filter((v) => v.startAt == null),
        getIsTrackProgramsCompleted: state => state.programs.filter((v) => v.status !== 'completed').length === 0,
        getUniqueProgramCompetences(state) {
            return uniqueCompetences(state.programs);
        },
        getCompetencesCoveredByTrack: (state, getters) => {
            return uniqueCompetences(getters.getTimelinePrograms);
        },
        getCompetencesForCoverTrack: (state, getters) => {
            let trackCompetenceIds = getters.getCompetencesCoveredByTrack.map((v) => v.id);
            return state.competences.filter(v => trackCompetenceIds.indexOf(v.id) === -1);
        },
        getCompetences: state => state.competences,
        getCurrentCompetence: state => state.currentCompetence,
        getSoftCompetences: state => state.competences.filter(v => v.competenceType === 'soft'),
        getHardCompetences: state => state.competences.filter(v => v.competenceType === 'hard'),
        getCompetenceLevels: state => state.competenceLevels,
        getCompetenceKnowledge: state => state.competenceKnowledge,
        getFirstDateOfTrack(state, getters) {
            if (getters.getTimelinePrograms.length === 0) {
                return null;
            }
            let date = getters.getTimelinePrograms.reduce((date, v) => {
                if (date === null || date.isAfter(v.moment.start)) {
                    date = v.moment.start;
                }
                return date;
            }, null);
            return date.clone();
        },
        getLastDateOfTrack(state, getters) {
            if (getters.getTimelinePrograms.length === 0) {
                return null;
            }
            let date = getters.getTimelinePrograms.reduce((date, v) => {
                if (v.modules && v.modules.length > 0) {
                    if (date === null || date.isBefore(v.modules[v.modules.length - 1].moment.end)) {
                        return v.modules[v.modules.length - 1].moment.end;
                    }
                    return date;
                }

                if (date === null || date.isBefore(v.moment.end)) {
                    return v.moment.end;
                }
                return date;
            }, null);
            return date.clone();
        },
        getStartOfTrack(state, getters) {
            return getters.getFirstDateOfTrack
                ? moment.min(moment(), getters.getFirstDateOfTrack.clone()).startOf('month')
                : null;
        },
        getEndOfTrack(state, getters) {
            return getters.getLastDateOfTrack
                ? getters.getLastDateOfTrack.clone()
                    .endOf('month')
                    .add(1, 'day')
                : null;
        },
        getProgramById: (state) => (id) => state.programs.find(v => v.id === id) || null,
        getModuleById: (state, getters) => (programId, moduleId) => {
            let item = getters.getProgramById(programId);
            if (!item) {
                return null;
            }
            return item.modules.find(v => v.id === moduleId) || null;
        },
        getCompetenceById: (state) => (id) => state.competences.find(v => v.id === id) || null,
        getProfessionById: (state) => (id) => state.professions.find(v => v.profileId === id) || null,
        getProfessions: state => state.professions,
        getPageContent: state => state.pageContent,
        getProftestId: state => state.proftestId,
        getProfessionRecommendations: state => state.professionRecommendations,
        getDirectSoftCompetences: (_, getters) => getters.getSoftCompetences.filter(el => el.isDirect),
        getDirectHardCompetences: (_, getters) => getters.getHardCompetences.filter(el => el.isDirect),
        getGoals: (_, getters) => [
            ...getters.getProfessions,
            ...getters.getDirectHardCompetences,
            ...getters.getDirectSoftCompetences,
        ],
        getHasMultipleGoals: (_, getters) => getters.getGoals.length > 1,
        getHasGoals: (_, getters) => getters.getGoals.length > 0,
    },
};

